import { render } from "./TagBox.vue?vue&type=template&id=0b46daea&scoped=true"
import script from "./TagBox.vue?vue&type=script&lang=js"
export * from "./TagBox.vue?vue&type=script&lang=js"

import "./TagBox.vue?vue&type=style&index=0&id=0b46daea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b46daea"]])

export default __exports__